import { Box, Button, FormControl, FormLabel, Input } from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login_failure, login_request, login_success } from "../Redux/authReducer/action";
import { Navigate, useNavigate } from "react-router-dom";

export default function Signin() {
    const [email,setEmail]=useState("")
    const [password,setPassword]=useState("")
    const dispatch=useDispatch()
    const navigate=useNavigate()
    let isAuth=useSelector((store)=>store.authReducer.isAuth)
    console.log(isAuth,"auth")
    const handleSubmit=()=>{
     let user={
        email,password
     }
    //  console.log(user)
    dispatch(login_request())
    axios.post(`https://reqres.in/api/login`,user)
    .then((res)=>{
        dispatch(login_success(res.data.token))
        console.log(res.data.token)
        navigate('/board')
    })
        
    .catch((err)=>{
        dispatch(login_failure())
        console.log(err.message)
    })
    }

  return (
    <Box width={"40%"} margin={"auto"} marginTop={"30px"} border={"2px solid black"} padding={"10px"}>
      <FormControl>
        <FormLabel>Email address</FormLabel>
        <Input type="email" onChange={(e)=>setEmail(e.target.value)}/>
        <FormLabel marginTop={"10px"}>Password</FormLabel>
        <Input type="text"  onChange={(e)=>setPassword(e.target.value)}/>
        <Button colorScheme="blue" marginTop={"10px"} width={"100%"} onClick={handleSubmit}>
          Submit
        </Button>
      </FormControl>
    </Box>
  );
}
